import { RouteRecordRaw } from 'vue-router';
import Layout from '@/layout/Layout.vue';
import { ROUTE } from '@/router/routes-enum';
import { RIGHT } from '@/api';

export const constantRoutes: RouteRecordRaw[] = [
  {
    path: '/',
    redirect: '/dashboard',
  },
  {
    path: '/dashboard',
    component: Layout,
    meta: { showInMenu: true },
    children: [
      {
        path: '',
        component: () => import('@/views/About.vue'),
        name: ROUTE.DASHBOARD,
        meta: { title: 'Dashboard', icon: 'grid', showInMenu: true },
      },
    ],
  },
  {
    path: '/404',
    name: ROUTE.ERR_404,
    component: () => import('@/views/errors-pages/404.vue'),
  },

  {
    path: '/500',
    name: ROUTE.ERR_500,
    component: () => import('@/views/errors-pages/500.vue'),
  },
];

export const protectedRoutes: RouteRecordRaw[] = [
  // пример использования вложенного меню:
  // {
  //   path: '/nested',
  //   component: Layout,
  //   meta: {
  //     title: 'Nested Menu', icon: 'edit', showInMenu: true,
  //   },
  //   children: [
  //     {
  //       path: 'index',
  //       component: () => import('@/views/About.vue'),
  //       name: 'Nested',
  //       meta: {
  //         title: 'Nested', icon: 'edit', showInMenu: true,
  //       },
  //     },
  //     {
  //       path: 'index2',
  //       component: () => import('@/views/About.vue'),
  //       name: 'Nested2',
  //       meta: { title: 'Nested2', icon: 'edit', showInMenu: true },
  //     },
  //   ],
  // },
  {
    path: '/profile',
    component: Layout,
    children: [
      {
        path: '',
        component: () => import('@/views/profile/Profile.vue'),
        name: ROUTE.PROFILE,
      },
    ],
  },
  {
    path: '/changelogs',
    component: Layout,
    meta: { title: 'Changelogs', icon: 'management', showInMenu: true },
    children: [
      {
        path: '',
        component: () => import('@/views/changelogs/Changelogs.vue'),
        name: ROUTE.CHANGELOGS,
        meta: {
          title: 'Changelogs',
          showInMenu: true,
          icon: 'management',
          rights: [RIGHT.READ_CHANGELOGS],
        },
      },
      {
        path: ':changelogId',
        name: ROUTE.CHANGELOG,
        meta: { showInMenu: false, rights: [RIGHT.READ_CHANGELOGS] },
        component: () => import('@/views/changelogs/Changelog.vue'),
      },
    ],
  },
  {
    path: '/users',
    component: Layout,
    meta: { showInMenu: true },
    children: [
      {
        path: '',
        component: () => import('@/views/users/Users.vue'),
        name: ROUTE.USERS,
        meta: {
          title: 'Users',
          icon: 'user-filled',
          showInMenu: true,
          rights: [RIGHT.MANAGE_USERS],
        },
      },
    ],
  },
  {
    path: '/games',
    component: Layout,
    meta: { title: 'Games', icon: 'coordinate', showInMenu: true },
    children: [
      {
        path: '',
        component: () => import('@/views/games/Games.vue'),
        name: ROUTE.GAMES,
        meta: {
          title: 'Games',
          showInMenu: true,
          icon: 'coordinate',
          rights: [RIGHT.READ_GAMES],
        },
      },
      {
        path: 'tags',
        component: () => import('@/views/tags/Tags.vue'),
        name: ROUTE.TAGS,
        meta: {
          title: 'Tags',
          showInMenu: true,
          icon: '',
          rights: [RIGHT.MANAGE_GAME_TAGS],
        },
      },
      {
        path: 'new',
        component: () => import('@/views/games/GameNew.vue'),
        name: ROUTE.GAME_NEW,
        meta: {
          title: 'Create',
          showInMenu: true,
          icon: 'circle-plus',
          rights: [RIGHT.CREATE_GAMES],
        },
      },
    ],
  },
  {
    path: '/comments',
    component: Layout,
    meta: {
      title: 'Comments',
      icon: 'comment',
      showInMenu: true,
      pinAsSubMenu: true,
    },
    children: [
      {
        path: 'unpublished',
        component: () => import('@/views/comments/components/Comments.vue'),
        name: ROUTE.COMMENTS_UNPUBLISHED,
        meta: {
          title: 'Unpublished',
          showInMenu: true,
          icon: () => 'unpublished',
          rights: [RIGHT.MANAGE_COMMENTS],
        },
      },
      {
        path: 'published',
        component: () => import('@/views/comments/components/Comments.vue'),
        name: ROUTE.COMMENTS_PUBLISHED,
        meta: {
          title: 'Published',
          showInMenu: true,
          icon: () => 'published',
          rights: [RIGHT.MANAGE_COMMENTS],
        },
      },
      {
        path: 'complaints',
        component: () => import('@/views/comments/components/Complaints.vue'),
        name: ROUTE.COMMENTS_COMPLAINTS,
        meta: {
          title: 'Complaints',
          showInMenu: true,
          icon: () => 'complaint',
          rights: [RIGHT.MANAGE_COMMENTS],
        },
      },
      {
        path: 'spam',
        component: () => import('@/views/comments/components/Comments.vue'),
        name: ROUTE.COMMENTS_SPAM,
        meta: {
          title: 'Spam',
          showInMenu: true,
          icon: () => 'spam',
          rights: [RIGHT.MANAGE_COMMENTS],
        },
      },
      {
        path: 'management',
        component: () => import('@/views/comments/components/Settings.vue'),
        name: ROUTE.COMMENTS_SETTINGS,
        meta: {
          title: 'Management',
          showInMenu: true,
          icon: 'setting',
          rights: [RIGHT.MANAGE_COMMENTS],
        },
      },
      {
        path: 'edit/:id',
        component: () => import('@/views/comments/components/CommentEdit.vue'),
        name: ROUTE.COMMENTS_EDIT,
        meta: {
          title: 'Edit comment',
          rights: [RIGHT.MANAGE_COMMENTS],
          showInMenu: false,
        },
      },
      {
        path: 'complaints/edit/:id',
        component: () => import('@/views/comments/components/ComplaintEdit.vue'),
        name: ROUTE.COMPLAINTS_EDIT,
        meta: {
          title: 'Edit complaint',
          rights: [RIGHT.MANAGE_COMMENTS],
          showInMenu: false,
        },
      },
    ],
  },
  {
    path: '/collections',
    component: Layout,
    meta: {
      title: 'Collections',
      icon: 'folder',
      showInMenu: true,
    },
    children: [
      {
        path: '',
        component: () => import('@/views/collections/CollectionsList.vue'),
        name: ROUTE.COLLECTIONS,
        meta: {
          title: 'Collections',
          showInMenu: true,
          icon: 'folder',
          rights: [RIGHT.MANAGE_COLLECTIONS],
        },
      },
      {
        path: 'new',
        component: () => import('@/views/collections/CollectionEditor.vue'),
        name: ROUTE.COLLECTION_NEW,
        meta: {
          title: 'Create Collection',
          showInMenu: false,
          rights: [RIGHT.MANAGE_COLLECTIONS],
        },
      },
      {
        path: ':collectionId',
        component: () => import('@/views/collections/CollectionEditor.vue'),
        name: ROUTE.COLLECTION_EDIT,
        meta: {
          title: 'Edit Collection',
          showInMenu: false,
          rights: [RIGHT.MANAGE_COLLECTIONS],
        },
      },
    ],
  },
  {
    path: '/providers',
    component: Layout,
    meta: {
      title: 'Providers',
      icon: 'shop',
      showInMenu: true,
      pinAsSubMenu: true,
    },
    children: [
      {
        path: 'provider-management',
        component: () => import('@/views/providers/components/AggregatorsProvidersList.vue'),
        name: ROUTE.PROVIDER_MANAGEMENT,
        meta: {
          title: 'Providers Management',
          showInMenu: true,
          icon: 'memo',
          rights: [RIGHT.MANAGE_AGGREGATORS],
        },
      },
      {
        path: 'currencies',
        component: () => import('@/views/currencies/Currencies.vue'),
        name: ROUTE.CURRENCIES,
        meta: {
          title: 'Currency management',
          showInMenu: true,
          icon: 'money',
          rights: [RIGHT.READ_CURRENCIES],
        },
      },
      {
        path: 'providers-fees',
        component: () => import('@/views/providers-fees/ProvidersFees.vue'),
        name: ROUTE.PROVIDERS_FEES,
        meta: {
          title: 'Provider Basic Fee',
          showInMenu: true,
          icon: 'Coin',
          rights: [RIGHT.MANAGE_PROVIDERS_DISCOUNTS],
        },
      },
      {
        path: 'providers-discounts',
        component: () => import('@/views/providers-discounts/ProvidersDiscounts.vue'),
        name: ROUTE.PROVIDERS_DISCOUNTS,
        meta: {
          title: 'Provider Discount',
          showInMenu: true,
          icon: 'Discount',
          rights: [RIGHT.MANAGE_PROVIDERS_DISCOUNTS],
        },
      },
    ],
  },
  {
    path: '/widgets',
    component: Layout,
    meta: {
      showInMenu: true,
      icon: 'postcard',
      title: 'Widgets',
      pinAsSubMenu: true,
    },
    children: [
      {
        path: 'game-of-week',
        component: () => import('@/views/games-of-week/GameOfWeekRedirect.vue'),
        name: ROUTE.GAME_OF_WEEK,
        meta: {
          title: 'Game of week',
          showInMenu: true,
          icon: 'flag',
          rights: [RIGHT.READ_GAME_OF_WEEK],
        },
      },
      {
        path: 'game-of-week/:presetId',
        component: () => import('@/views/games-of-week/GameOfWeekList.vue'),
        name: ROUTE.GAME_OF_WEEK_LIST,
        meta: {
          title: 'Game of week',
          rights: [RIGHT.READ_GAME_OF_WEEK],
          showInMenu: false,
        },
      },
      {
        path: 'game-of-week/:presetId/new',
        component: () => import('@/views/games-of-week/GameOfWeekNew.vue'),
        name: ROUTE.GAME_OF_WEEK_NEW,
        meta: {
          title: 'Create game of week',
          rights: [RIGHT.CREATE_GAME_OF_WEEK],
          showInMenu: false,
        },
      },
      {
        path: 'game-of-week/:presetId/edit/:id',
        component: () => import('@/views/games-of-week/GameOfWeekEdit.vue'),
        name: ROUTE.GAME_OF_WEEK_EDIT,
        meta: {
          title: 'Edit game of week',
          rights: [RIGHT.UPDATE_GAME_OF_WEEK],
          showInMenu: false,
        },
      },
      {
        path: 'hot-and-cold',
        component: () => import('@/views/hot-cold-games/components/HotColdGames.vue'),
        name: ROUTE.HOT_COLD,
        meta: {
          icon: () => 'hotcold',
          title: 'Hot&Cold Games',
          rights: [RIGHT.MANAGE_GAME_CATEGORIES],
          showInMenu: true,
        },
      },
    ],
  },
  {
    path: '/categories',
    name: ROUTE.GAME_CATEGORIES_WRAP,
    component: Layout,
    meta: {
      showInMenu: true,
      icon: 'menu',
      title: 'Categories',
      pinAsSubMenu: true,
    },
    children: [
      {
        path: ':presetId?',
        name: ROUTE.GAME_CATEGORIES,
        component: () => import('@/views/categories/Categories.vue'),
        meta: {
          title: 'Categories',
          showInMenu: false,
          rights: [RIGHT.MANAGE_CATEGORY_LOCALE_SETTINGS],
        },
      },
    ],
  },
  {
    path: '/dev',
    component: Layout,
    meta: {
      title: 'Dev',
      icon: 'cpu',
      showInMenu: true,
      pinAsSubMenu: true,
    },
    children: [
      {
        path: 'keys',
        component: () => import('@/views/dev/ApiKeys.vue'),
        name: ROUTE.API_KEYS,
        meta: {
          title: 'API-keys',
          showInMenu: true,
          icon: 'key',
          rights: [RIGHT.MANAGE_API_KEYS],
        },
      },
      {
        path: 'keys/new',
        component: () => import('@/views/dev/NewApiKey.vue'),
        name: ROUTE.NEW_API_KEY,
        meta: {
          title: 'New API-key',
          showInMenu: false,
          icon: 'key',
          rights: [RIGHT.MANAGE_API_KEYS],
        },
      },
    ],
  },
  {
    path: '/settings',
    component: Layout,
    meta: {
      title: 'Settings',
      icon: 'setting',
      showInMenu: true,
    },
    children: [
      {
        path: 'tenant',
        component: () => import('@/views/settings/TenantSettings.vue'),
        name: ROUTE.SETTINGS_TENANT,
        meta: {
          title: 'Settings',
          showInMenu: true,
          icon: 'setting',
          rights: [RIGHT.MANAGE_TENANT_SETTINGS],
        },
      },
    ],
  },
  // 404 page must be placed at the end !!!
  { path: '/:catchAll(.*)', redirect: '/404' },
];
